module.exports = __webpack_public_path__ + "img/1-4.831f4d86.png";